export default __webpack_public_path__ + "resources/icons/d322-859b.png";